import { render, staticRenderFns } from "./StockRecalls.vue?vue&type=template&id=025c37d4"
import script from "./StockRecalls.vue?vue&type=script&lang=js"
export * from "./StockRecalls.vue?vue&type=script&lang=js"
import style0 from "./StockRecalls.vue?vue&type=style&index=0&id=025c37d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports